const mutationTicketComment = `mutation newTicketComment($body:String!, $ticketId:[Int]) {
  upsertComments(
    body: $body,
    commentTicket: $ticketId
  ) {
    id
  }
}`;

export { mutationTicketComment };